function openTab(evt, tabTitle) {
 var i, x, tablinks;
  x = document.getElementsByClassName("st-title");
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tabbtn");
  for (i = 0; i < x.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" st-active", "");
  }
  document.getElementById(tabTitle).style.display = "block";
  evt.currentTarget.className += " st-active";
}